import { useCMSPageField } from '@/cms/fields'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createDataLayerEvent } from '@/scopes/products/pages/components/Legacy/PracticalInformation/helpers/CreateDataLayerEvent'
import { Accordion, Typography } from '@sunwebgroup/ui-components'

export interface GoodToKnowProps {
  title: string
}

export function GoodToKnow({ title }: GoodToKnowProps) {
  const info = useCMSPageField('PDP.attention')
  const { sendEvent } = useAnalytics()

  if (info === '')
    return null

  const handleChange = (isOpen: boolean) => {
    if (isOpen) {
      sendEvent(createDataLayerEvent({ element: 'Good to know', isOpen: true }))
    }
    else {
      sendEvent(createDataLayerEvent({ element: 'Good to know', isOpen: false }))
    }
  }

  return (
    <Accordion.Item title={title} icon="IconInformationCircle" onOpenChange={handleChange}>
      <Typography dangerouslySetInnerHTML={{ __html: info }} />
    </Accordion.Item>
  )
}
